import type { ApolloError } from "apollo-server-express";
import type { ValidationErrorData } from "..";

export type ParsedError<T> =
    | {
          type: "VALIDATION";
          data: Partial<{ [key in keyof T]: ValidationErrorData }>;
      }
    | {
          type: "IN_USE";
      }
    | {
          type: "NOT_FOUND";
      }
    | {
          type: "NOT_UNIQUE";
          data: (keyof T)[];
      }
    | { type: "INVALID_ARGUMENTS"; data: string };

export function parseError<T>(
    error: Pick<
        ApolloError,
        "graphQLErrors" | "networkError" | "message" | "name"
    >
): ParsedError<T> {
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        return {
            type: error.graphQLErrors[0].extensions!.type,
            data: error.graphQLErrors[0].extensions!.data,
        };
    } else if (error.networkError && error.networkError.length > 0) {
        return {
            type: error.networkError[0].extensions!.type,
            data: error.networkError[0].extensions!.data,
        };
    } else {
        return {
            type: error?.name as any,
            data: error?.message as any,
        };
    }
}
